import { createSelector } from 'reselect';
import EmployeesConstants from 'Shared/constants/Employees.constants';

const getEmployees = state => state.PiEmployeeItems;

export const getAllEmployeesEmail = createSelector([getEmployees], employees =>
  employees.get(EmployeesConstants.State.EMPLOYEES_EMAIL)
);
